import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import classes from '../asset/css/complete.module.css';

export const Complete: FC<{ title: string; body: string; backTo: string; isParent: boolean }> = ({
  title,
  body,
  backTo,
  isParent,
}) => {
  const backBtnHtml = isParent ? (
    <a href={backTo} target="_parent">
      もどる
    </a>
  ) : (
    <Link to={backTo}>もどる</Link>
  );

  return (
    <>
      <div className={classes.mypage_subsc_complete}>
        <h2>{title}</h2>
        <p dangerouslySetInnerHTML={{ __html: body }} />
        <div className={classes.mypage_subsc_back_button}>{backBtnHtml}</div>
      </div>
    </>
  );
};
